"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import TextSliderSkeleton from "./_skeletons/TextSliderSkeleton";

export const TextSlider = () => {
  const { trans } = useUtility();
  const { content, loading } = useSection("text_slider");

  if (loading) {
    return <TextSliderSkeleton />;
  }

  return (
    <div className="text-slider-section">
      <div className="text-slider-outer">
        <div className="text-slider-inner">
          <h1 className="text-slider-title">{trans(content?.text)}</h1>
        </div>
      </div>
    </div>
  );
};
